import styled from "styled-components";
import { TEXT_COLORS } from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";

export const Container = styled.div`
  height: ${COMPONENTS.footer.desktop}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${SPACING.three}px;
`;

export const BlockContainer = styled.a`
  ${FONT_CSS.body.five}
  text-decoration: none;
  cursor: pointer;
  color: ${TEXT_COLORS.one};

  &:hover {
    color: ${TEXT_COLORS.one};
  }

  span:first-child {
    ${FONT_CSS.label.two}
    color: ${TEXT_COLORS.three};
  }
`;

export const LeftContainer = styled.div`
  display: flex;
`;

// Center section holding the keyboard hint bar. Flexes to fill the middle and
// truncates (overflow hidden) before the right-hand block/version is pushed off.
export const CenterContainer = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: center;
  overflow: hidden;
  margin: 0 ${SPACING.three}px;
`;

export const RightContainer = styled.div`
  display: flex;

  a {
    ${FONT_CSS.label.two}
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const SocialIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.three}px;
`;

export const SocialIconLink = styled.a`
  display: flex;
  align-items: center;
  color: ${TEXT_COLORS.three};
  transition: color 0.15s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${TEXT_COLORS.one};
  }
`;
